/* Purry Purry — Size Chart Drawer Logic (matches pp-sizechart__ markup) */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // Event delegation so it works on product & featured product sections
    document.addEventListener('click', function (e) {
      // OPEN
      const opener = e.target.closest('[data-pp-open-sizechart]');
      if (opener) {
        e.preventDefault();
        const drawer = document.getElementById('pp-sizechart-drawer');
        if (!drawer) { console.warn('pp-size-chart: drawer snippet not found'); return; }
        openDrawer(drawer);
        return;
      }

      // CLOSE via X or overlay
      const closeEl = e.target.closest('[data-pp-close-sizechart]');
      if (closeEl) {
        const drawer = document.getElementById('pp-sizechart-drawer');
        if (drawer) closeDrawer(drawer);
        return;
      }
    });

    // ESC to close
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      const drawer = document.getElementById('pp-sizechart-drawer');
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        e.preventDefault();
        closeDrawer(drawer);
      }
    });

    function openDrawer(drawer) {
      const panel = drawer.querySelector('.pp-sizechart__panel');
      drawer.dataset.ppLastFocus = document.activeElement && document.activeElement.id ? ('#' + document.activeElement.id) : '';
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ppsc-lock');
      document.body.style.overflow = 'hidden';
      setTimeout(function(){ panel && panel.focus(); }, 0);
    }

    function closeDrawer(drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ppsc-lock');
      document.body.style.overflow = '';
      const lastSel = drawer.dataset.ppLastFocus;
      if (lastSel) {
        try {
          const el = document.querySelector(lastSel);
          if (el && typeof el.focus === 'function') el.focus();
        } catch(_) {}
      }
    }
  });
})();
